// extracted by mini-css-extract-plugin
export default {"content":"AccountDeletion_content__dW-Fb","modal":"AccountDeletion_modal__PvOhv","title":"AccountDeletion_title__K5jZf"};